import { Component, OnInit } from '@angular/core';
import {  Router } from '@angular/router';
import { GlobalConstants } from '../../../common/constants/global.constant';
import { environment } from '../../../../../src/environments/environment';
import { CommonService } from '../../../common/services/common.service';
import { Utils } from '../../../common/utils/utils';

@Component({
  selector: 'iposcen-game-demos',
  templateUrl: './game-demos.component.html',
  styleUrls: ['./game-demos.component.scss']
})
export class GameDemosComponent implements OnInit {
  globalconst = GlobalConstants;
  currentPage = this.router.url;
  ifUnisonDemo:boolean = false;
  ifStandDwnld:boolean = false;
  showUnisonErrorMsg: boolean = false;
  showMHRErrorMsg: boolean = false;
  showChorusErrorMsg: boolean = false;
  gameTypes = {
    mhr: false,
    chorus: false,
    synched: false,
    gr:false
  };
  constructor(
    private commonService: CommonService,
    private router: Router) { }

  ngOnInit(): void {
    const pageName = this.currentPage.lastIndexOf('/');
    if(this.currentPage.substring(pageName + 1) === GlobalConstants.UNISON_DEMO){
      this.ifUnisonDemo = true;
    }
    if(this.currentPage.substring(pageName + 1) === GlobalConstants.STANDARD_DOWNLAOD || this.currentPage.includes(this.globalconst.PROFILE_URL)){
      this.ifStandDwnld = true;
    }
  }

  // function to download games IIT2-8315
  async downloadGames(gamename) {
    let url;
    let filename;
    switch (gamename) {
      case this.globalconst.MONSTER_HUNTER_SUNBREAK_VALUE: {
        url = environment.apiBaseUrl + this.globalconst.MHR_LINK;
        filename = this.globalconst.MHR_FILENAME;
        break;
      }
      case this.globalconst.CHORUS_VALUE: {
        url = environment.apiBaseUrl + this.globalconst.CHORUS_LINK;
        filename = this.globalconst.CHORUS_FILENAME;
        break;
      }
      case this.globalconst.UNISON_VALUE: {
        url = environment.apiBaseUrl + this.globalconst.UNISON_LINK;
        filename = this.globalconst.UNISON_FILENAME;
        break;
      }
      case this.globalconst.SYNCHED_VALUE: {
        url = environment.apiBaseUrl + this.globalconst.SYNCHED_LINK;
        filename = this.globalconst.SYNCHED_FILENAME;
        break;
      }
      case this.globalconst.GR_VALUE: {
        url = environment.apiBaseUrl + this.globalconst.GR_LINK;
        filename = this.globalconst.GR_FILENAME;
        break;
      }
    }

    const resURL = await Utils.getFileXHRResponseContext(url);
    const fileError = resURL.toString().includes(GlobalConstants.DONWLOAD_ERROR_PAGE_NAME) ? true : false;
    if (fileError) {
      this.showMHRErrorMsg = (gamename === this.globalconst.MONSTER_HUNTER_SUNBREAK_VALUE) ? true : false;
      this.showChorusErrorMsg = (gamename === this.globalconst.CHORUS_VALUE) ? true : false;
      this.showUnisonErrorMsg = (gamename === this.globalconst.UNISON_VALUE) ? true : false;
    } else {
      this.showMHRErrorMsg = this.showChorusErrorMsg = this.showUnisonErrorMsg = false;
      this.commonService.downloadPackage(url, filename, "");
    }
  }

  // Expand/collpase
  collpaseExpand(type){
    this.gameTypes[type] = !this.gameTypes[type];
  }

}
